import {
  faMagnifyingGlass,
  faMoon,
  faSun,
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect } from 'react';
import { IconButton } from '@/components/shared/IconButton';
import { useDocsSearchStore } from '@/store/docsSearchStore';
import { useThemeStore } from '@/store/themeStore';

export default function DocsHeader() {
  const { theme, setThemeAnimated } = useThemeStore();
  const setOpen = useDocsSearchStore(s => s.setOpen);

  const dark =
    theme === 'dark' ||
    (theme === 'system' &&
      typeof window !== 'undefined' &&
      window.matchMedia('(prefers-color-scheme: dark)').matches);

  useEffect(() => {
    function onKeyDown(e: KeyboardEvent) {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        useDocsSearchStore.setState(s => ({ open: !s.open }));
      }
    }
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, []);

  return (
    <header className='col-span-2 flex items-center gap-4 px-4 @2xl:px-6 border-b bg-background z-30 h-13'>
      {/* Logo + Docs label */}
      <div className='flex items-center gap-3 shrink-0'>
        <img
          src={`${import.meta.env.VITE_CDN_URI}/static/dashboard-service/secondary-logo-black-v2.svg`}
          alt='Retraced'
          className='h-5 w-auto dark:hidden'
        />
        <img
          src={`${import.meta.env.VITE_CDN_URI}/static/dashboard-service/secondary-logo-cloud-v2.svg`}
          alt='Retraced'
          className='h-5 w-auto hidden dark:block'
        />
        <span className='text-xs font-semibold text-muted-foreground border-l border-border pl-3 tracking-wide uppercase'>
          Docs
        </span>
      </div>

      {/* Search trigger */}
      <button
        type='button'
        onClick={() => setOpen(true)}
        className='flex items-center gap-2 flex-1 max-w-xs h-8 px-2.5 rounded-md bg-muted/40 border border-border/60 text-xs text-muted-foreground hover:bg-muted/70 hover:border-border transition-colors'
      >
        <FontAwesomeIcon
          icon={faMagnifyingGlass}
          className='size-3.5 shrink-0'
        />
        <span className='flex-1 text-left'>Search docs…</span>
        <kbd className='hidden @2xl:flex items-center gap-0.5 text-xs font-mono opacity-60'>
          ⌘K
        </kbd>
      </button>

      {/* Spacer */}
      <div className='flex-1' />

      {/* Theme toggle */}
      <IconButton
        variant='ghost'
        size='icon'
        className='h-7.5 w-7.5 text-muted-foreground shrink-0'
        onClick={e => {
          const rect = e.currentTarget.getBoundingClientRect();
          setThemeAnimated(
            dark ? 'light' : 'dark',
            rect.left + rect.width / 2,
            rect.top + rect.height / 2,
          );
        }}
        tooltip={dark ? 'Switch to light mode' : 'Switch to dark mode'}
      >
        {dark ? (
          <FontAwesomeIcon icon={faMoon} className='size-3.5' />
        ) : (
          <FontAwesomeIcon icon={faSun} className='size-3.5' />
        )}
      </IconButton>
    </header>
  );
}
